import { FormikHelpers, FormikState } from "formik";
import { isArray } from "lodash";

// This is used to handle adding and removing items from formik array fields
export function handleFormikArray<Type>(formik: FormikHelpers<Type> & FormikState<Type>, excludeMode = false) {
    return (field: Extract<keyof Type, string>) => (e: React.ChangeEvent<HTMLInputElement>) => {
        const { checked, name } = e.target;
        const val = formik.values[field];

        if (!isArray(val)) return;

        if ((!excludeMode && checked) || (excludeMode && !checked)) {
            formik.setFieldValue(field, [...val, name]);
        } else {
            formik.setFieldValue(
                field,
                val.filter((v) => v !== name)
            );
        }

        formik.submitForm();
    };
}
